export const filterSuggestion = (suggestion, user = {}) => {
	if (suggestion?.type === 'TM') {
		return suggestion?.score >= user?.minMatchRateTM;
	}

	if (user?.hideMatchesMT && suggestion?.type === 'MT') {
		return false;
	}

	return true;
};

export const getSuggestionSourceTaskID = (suggestion) => {
	const storedTaskID = suggestion?.metas?.createdTaskID;
	if (storedTaskID !== undefined && storedTaskID !== null && storedTaskID !== '') {
		return Number(storedTaskID) || null;
	}

	const taskLink = String(suggestion?.metas?.taskLink ?? '');
	const match = taskLink.match(/\/task\/(\d+)(?:\/|$)/);
	return Number(match?.[1]) || null;
};

export const buildSuggestionCollections = (suggestions = [], user = {}) => {
	const sortedSuggestions = [...suggestions].sort((a, b) => {
		if (a.score > b.score) return -1;
		if (a.score < b.score) return 1;

		return 0;
	});

	const allSuggestions = sortedSuggestions.filter((suggestion) =>
		filterSuggestion(suggestion, user)
	);

	const tmMatches = allSuggestions
		.filter((item) => item.type === 'TM')
		.slice(0, user?.maxNumberOfSuggestions ?? 20);
	const tbSuggestions = allSuggestions.filter((item) => item.type === 'TB');
	const mtSuggestions = allSuggestions.filter((item) => item.type === 'MT');
	const aiSuggestions = allSuggestions.filter((item) => item.type === 'AI');

	const tmSuggestions = aiSuggestions.concat(mtSuggestions, tmMatches);
	const combinedSuggestions = user?.showTbBottom
		? tmSuggestions.concat(tbSuggestions)
		: tbSuggestions.concat(tmSuggestions);

	return {
		tmSuggestions,
		tbSuggestions,
		combinedSuggestions,
	};
};

export const getVisibleSuggestions = (suggestions = [], user = {}, mode = 'tm') => {
	const { tmSuggestions, tbSuggestions, combinedSuggestions } =
		buildSuggestionCollections(suggestions, user);

	if (!user?.showTbInSeparateTab) {
		return combinedSuggestions;
	}

	return mode === 'tb' ? tbSuggestions : tmSuggestions;
};
